import * as React from 'react';
import { cn } from '@/lib/utils';

const LessonMessageWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-wrapper', 'flex max-w-full flex-col gap-3 overflow-y-auto p-3', className)}
    {...props}
  />
));
LessonMessageWrapper.displayName = 'LessonMessageWrapper';

const LessonMessageDivider = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-lesson-message-divider', 'mb-0 flex justify-center gap-1 rounded-sm bg-neutral-bright px-2 py-1 text-xs text-neutral-dark [&>svg]:w-4', className)}
    {...props}
  />
));
LessonMessageDivider.displayName = 'LessonMessageDivider';

const LessonMessageContainer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-container', 'flex items-start gap-6 rounded-xl bg-white p-4 transition-all hover:shadow-dropshadow-md', className)}
    {...props}
  />
));
LessonMessageContainer.displayName = 'LessonMessageContainer';

const LessonMessage = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message', 'flex w-28 grow flex-col items-start gap-3 xl:flex-row', className)}
    {...props}
  />
));
LessonMessage.displayName = 'LessonMessage';

const LessonMessageUser = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-user', 'flex w-full max-w-full shrink-0 flex-row gap-2 xl:w-28 xl:flex-col', className)}
    {...props}
  />
));
LessonMessageUser.displayName = 'LessonMessageUser';

const LessonMessageInfo = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-info', 'flex flex-col', className)}
    {...props}
  />
));
LessonMessageInfo.displayName = 'LessonMessageInfo';

const LessonMessageName = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-lesson-message-name', 'mb-0 min-w-full max-w-full truncate text-sm font-bold text-primary-dark', className)}
    {...props}
  />
));
LessonMessageName.displayName = 'LessonMessageName';

const LessonMessageDateTime = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-lesson-message-datetime', 'mb-0 text-xs font-bold text-neutral', className)}
    {...props}
  />
));
LessonMessageDateTime.displayName = 'LessonMessageDateTime';

const LessonMessageContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-content', 'wrap w-full grow break-words xl:w-52', className)}
    {...props}
  />
));
LessonMessageContent.displayName = 'LessonMessageContent';

const LessonMessageActions = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-actions', 'flex shrink-0 flex-col gap-3 [&_svg]:w-5 [&_svg]:cursor-pointer', className)}
    {...props}
  />
));
LessonMessageActions.displayName = 'LessonMessageActions';

const LessonMessageFile = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-file', 'flex items-center gap-2', className)}
    {...props}
  />
));
LessonMessageFile.displayName = 'LessonMessageFile';

const LessonMessageFileThumb = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-file-thumb', '[&_svg]:h-8 [&_svg]:w-11 [&_svg]:rounded-sm [&_svg]:border [&_svg]:border-solid [&_svg]:border-neutral-lightest [&_svg]:object-cover', className)}
    {...props}
  />
));
LessonMessageFileThumb.displayName = 'LessonMessageFileThumb';

const LessonMessageFileContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-message-file-content', 'flex w-16 grow flex-col', className)}
    {...props}
  />
));
LessonMessageFileContent.displayName = 'LessonMessageFileContent';

const LessonMessageFileTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn('c-lesson-message-file-title', 'mb-0 truncate text-xs font-bold text-primary-dark', className)}
    {...props}
  />
));
LessonMessageFileTitle.displayName = 'LessonMessageFileTitle';

const LessonMessageFileMeta = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-lesson-message-file-meta', 'mb-0 truncate text-xs text-neutral', className)}
    {...props}
  />
));
LessonMessageFileMeta.displayName = 'LessonMessageFileMeta';

export {
  LessonMessageWrapper,
  LessonMessageDivider,
  LessonMessageContainer,
  LessonMessage,
  LessonMessageUser,
  LessonMessageInfo,
  LessonMessageName,
  LessonMessageDateTime,
  LessonMessageContent,
  LessonMessageActions,
  LessonMessageFile,
  LessonMessageFileThumb,
  LessonMessageFileContent,
  LessonMessageFileTitle,
  LessonMessageFileMeta
};
